var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRisk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 1.25C19.4142 1.25 19.75 1.58579 19.75 2V6C19.75 6.41421 19.4142 6.75 19 6.75C18.5858 6.75 18.25 6.41421 18.25 6V2C18.25 1.58579 18.5858 1.25 19 1.25Z",
    fill: "#C4C4CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5117 9.44142C19.8196 9.71851 19.8446 10.1927 19.5675 10.5006L19.5575 10.5117C19.2804 10.8196 18.8062 10.8446 18.4983 10.5675C18.1904 10.2904 18.1654 9.81616 18.4425 9.50828L18.4525 9.49716C18.7296 9.18928 19.2038 9.16432 19.5117 9.44142Z",
    fill: "#C4C4CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 8.75H14C14.4142 8.75 14.75 8.41421 14.75 8C14.75 7.58579 14.4142 7.25 14 7.25H8.6C7.85441 7.25 7.25 7.85442 7.25 8.6V15.4C7.25 16.1456 7.85442 16.75 8.6 16.75H15.4C16.1456 16.75 16.75 16.1456 16.75 15.4V14C16.75 13.5858 16.4142 13.25 16 13.25C15.5858 13.25 15.25 13.5858 15.25 14V15.25H8.75V8.75Z",
    fill: "#C4C4CD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 4.75H14C14.4142 4.75 14.75 4.41421 14.75 4C14.75 3.58579 14.4142 3.25 14 3.25H4.6C3.85442 3.25 3.25 3.85441 3.25 4.6V19.4C3.25 20.1456 3.85441 20.75 4.6 20.75H19.4C20.1456 20.75 20.75 20.1456 20.75 19.4V14C20.75 13.5858 20.4142 13.25 20 13.25C19.5858 13.25 19.25 13.5858 19.25 14V19.25H4.75V4.75Z",
    fill: "#C4C4CD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 17C19.25 16.5858 19.5858 16.25 20 16.25H22C22.4142 16.25 22.75 16.5858 22.75 17C22.75 17.4142 22.4142 17.75 22 17.75H20C19.5858 17.75 19.25 17.4142 19.25 17Z",
    fill: "#C4C4CD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 19.25C17.4142 19.25 17.75 19.5858 17.75 20V22C17.75 22.4142 17.4142 22.75 17 22.75C16.5858 22.75 16.25 22.4142 16.25 22V20C16.25 19.5858 16.5858 19.25 17 19.25Z",
    fill: "#C4C4CD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 19.25C12.4142 19.25 12.75 19.5858 12.75 20V22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22V20C11.25 19.5858 11.5858 19.25 12 19.25Z",
    fill: "#C4C4CD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 19.25C7.41421 19.25 7.75 19.5858 7.75 20V22C7.75 22.4142 7.41421 22.75 7 22.75C6.58579 22.75 6.25 22.4142 6.25 22V20C6.25 19.5858 6.58579 19.25 7 19.25Z",
    fill: "#C4C4CD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 17C1.25 16.5858 1.58579 16.25 2 16.25H4C4.41421 16.25 4.75 16.5858 4.75 17C4.75 17.4142 4.41421 17.75 4 17.75H2C1.58579 17.75 1.25 17.4142 1.25 17Z",
    fill: "#C4C4CD"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 12C1.25 11.5858 1.58579 11.25 2 11.25H4C4.41421 11.25 4.75 11.5858 4.75 12C4.75 12.4142 4.41421 12.75 4 12.75H2C1.58579 12.75 1.25 12.4142 1.25 12Z",
    fill: "#C4C4CD"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 7C1.25 6.58579 1.58579 6.25 2 6.25H4C4.41421 6.25 4.75 6.58579 4.75 7C4.75 7.41421 4.41421 7.75 4 7.75H2C1.58579 7.75 1.25 7.41421 1.25 7Z",
    fill: "#C4C4CD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V4C12.75 4.41421 12.4142 4.75 12 4.75C11.5858 4.75 11.25 4.41421 11.25 4V2C11.25 1.58579 11.5858 1.25 12 1.25Z",
    fill: "#C4C4CD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1.25C7.41421 1.25 7.75 1.58579 7.75 2V4C7.75 4.41421 7.41421 4.75 7 4.75C6.58579 4.75 6.25 4.41421 6.25 4V2C6.25 1.58579 6.58579 1.25 7 1.25Z",
    fill: "#C4C4CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk);
export default __webpack_public_path__ + "static/media/Risk.992c1258e36e63ab2a2cf0730dc47f42.svg";
export { ForwardRef as ReactComponent };